import React, { useState, useEffect } from "react";
import { Link } from "@reach/router";
import logoDark from "../../assets/logo/Fraktionlogo_white.png";
import logoWhite from "../../assets/logo/logo-color.png";
import logoSmall from "../../assets/logo/wallex_white.svg";
import wallexLogo from '../../assets/wallex_updated.svg'
import facebook from '../../assets/facebook.svg'
import twitter from '../../assets/twitter.svg'
import linkedin from '../../assets/linkedin.svg'
import instagram from '../../assets/instagram.svg'
import medium from '../../assets/medium.svg'

const Footer = () => {
  const [isDark, setIsDark] = useState(false);
  useEffect(() => {
    if (localStorage.getItem("mode") === "dark") {
      setIsDark(true);
    } else if (localStorage.getItem("mode") === "light") {
      setIsDark(false);
    }
  }, []);
  
  return (
    <footer
      className="headerColor gradient-border-footer"
      style={{ paddingTop: "50px" }}
    >
      <div className="container ">
        <div className="row">
        <div className="footer_social_container">
     <img src={wallexLogo} alt="asd" />

     <div>
      <h6 className="whiteColor">Follow us</h6>
      <div>
      

      <a rel="noreferrer" href="https://www.facebook.com/profile.php?id=100083728852015&mibextid=LQQJ4d" target="_blank">
      <img src={facebook} alt="facebook"/> &nbsp;&nbsp;
      </a>
        
        <a rel="noreferrer" href="https://twitter.com/wallex_official" target="_blank">
      <img src={twitter} alt="twitter"/>
      </a>
        &nbsp;&nbsp;
        <a rel="noreferrer" href="https://www.linkedin.com/company/wallextrustcustody/" target="_blank">
        <img src={linkedin} alt="linkedin"/>
        </a>
        &nbsp;&nbsp;
        <a rel="noreferrer" href="https://www.instagram.com/wallex_global/" target="_blank">
        <img src={instagram} alt="instagram"/>
        </a>
        &nbsp;&nbsp;
        <a rel="noreferrer" href="https://medium.com/@wallexcustody/" target="_blank">
        <img src={medium} alt="medium"/>
        </a>
       
      </div>
     </div>
        </div>
          <div className="col-md-3 col-sm-6 col-xs-1">
            <div className="widget whiteColor">
              <h5 className="whiteColor">Marketplace</h5>
              <ul className="whiteColor">
                <li>
                  <Link to="/Explore" className="whiteColor">
                    All NFTs
                  </Link>
                </li>
                <li>
                  <Link to="/Explore" className="whiteColor">
                    Art
                  </Link>
                </li>
                <li>
                  <Link to="/Explore" className="whiteColor">
                    Music
                  </Link>
                </li>
                {/* <li>
                  <Link to="" className="whiteColor">
                    Domain Names
                  </Link>
                </li>
                <li>
                  <Link to="" className="whiteColor">
                    Virtual World
                  </Link>
                </li> */}
                <li>
                  <Link to="" className="whiteColor">
                    Collectibles
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 col-xs-1">
            <div className="widget">
              <h5 className="whiteColor">Resources</h5>
              <ul className="whiteColor">
                <li>
                  <Link to="/helpcenter-new" className="whiteColor">
                    Help Center
                  </Link>
                </li>
                <li>
                  <Link to="" className="whiteColor">
                    Partners
                  </Link>
                </li>
                <li>
                  <Link to="" className="whiteColor">
                    Suggestions
                  </Link>
                </li>
                <li>
                  <Link to="" className="whiteColor">
                    Discord
                  </Link>
                </li>
                <li>
                  <Link to="" className="whiteColor">
                    Docs
                  </Link>
                </li>
                <li>
                  <Link to="" className="whiteColor">
                    Newsletter
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 col-xs-1">
            <div className="widget">
              <h5 className="whiteColor">Community</h5>
              <ul className="whiteColor">
                <li>
                  <Link to="" className="whiteColor">
                    Community
                  </Link>
                </li>
                <li>
                  <Link to="" className="whiteColor">
                    Documentation
                  </Link>
                </li>
                <li>
                  <Link to="" className="whiteColor">
                    Brand Assets
                  </Link>
                </li>
                <li>
                  <Link to="" className="whiteColor">
                    Blog
                  </Link>
                </li>
                <li>
                  <Link to="" className="whiteColor">
                    Forum
                  </Link>
                </li>
                <li>
                  <Link to="" className="whiteColor">
                    Mailing List
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 col-xs-1">
            <div className="widget ">
              <h5 className="whiteColor">Newsletter</h5>
              <p className="whiteColor">
                Signup for our newsletter to get the latest news in your inbox.
              </p>
              <form
                action="#"
                className="row form-dark"
                id="form_subscribe"
                method="post"
                name="form_subscribe"
              >
                <div className="col text-center input-flex email-search">
                  <input
                    className=" noInput"
                    id="txt_subscribe"
                    name="txt_subscribe"
                    placeholder="enter your email"
                    type="text"
                  />
                  <Link to="/" id="btn-subscribe">
                    <i
                      className="arrow_right bg-color-secondary"
                      style={{
                        width: "30px",
                        color: "#2EC3CE",
                        marginLeft: "-30px",
                      }}
                    ></i>
                  </Link>
                  {/* <div className="clearfix"></div> */}
                </div>
              </form>
              <div className="spacer-10"></div>
              <small className="whiteColor">
                Your email is safe with us. We don't spam.
              </small>
            </div>
          </div>
        </div>
      </div>
      <div className="subfooter ">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="de-flex">
                <div className="de-flex-col">
                  <span onClick={() => window.open("", "_self")}>
                    {/* <hr/> */}

                    <div className="footer_line"></div>

                    <div>
                      <h6 className="footer_last_title">©2023 WallexCUSTODY. All rights reserved</h6>
                      <p className="footer_last_content">
                        Wallex CUSTODY Services are not available in United
                        States and other prohibited jurisdictions. No legal,
                        tax, investment, or other advice is provided by any
                        Wallex entity. Please consult your legal/tax/investment
                        professional for questions about your specific
                        circumstances. Digital asset holdings involve a high
                        degree of risk, and can fluctuate greatly on any given
                        day. Accordingly, your digital asset holdings may be
                        subject to large swings in value and may even become
                        worthless.
                      </p>
                    </div>

                    {/* <img className="f-logo d-1"   alt="#"
                    width='50%'
                    height='50%'src={logoSmall} style={{marginTop:'-10px'}} /> */}

                    {/* <div className="logo-nft">
                <img
                   src={logoSmall}
                    alt="#"
                    width='50%'
                    height='50%'
                    style={{marginTop:'-10px'}}
                  />
                  <div className="vertical-line"></div>
                  <h3 className="mildWhite" style={{marginTop:'20px'}}>
                    NFT
                  </h3>
                  </div> */}
                    {/* <img alt="" className="f-logo d-3" src={logoSmall} />
                                              <img alt="" className="f-logo d-4" src={logoSmall}/> */}
                    {/* {
                                                  isDark?
                                                  <img alt='' src={logoDark} width='150px'/>:
                                                  <img alt='' src={logoWhite} width='150px'/>
                                              } */}

                    {/* <h3 className='whiteColor' style={{marginTop:'15px'}}>Wallex</h3> */}
                  </span>
                </div>
                {/* <div className="de-flex-col">
                                          <div className="social-icons">
                                          <span className="copy whiteColor" >Copyright © 2022 Wallex. All rights reserved.</span> */}
                {/* <span onClick={()=> window.open("", "_self")}><i className="fa fa-facebook fa-lg"></i></span>
                                              <span onClick={()=> window.open("", "_self")}><i className="fa fa-twitter fa-lg"></i></span>
                                              <span onClick={()=> window.open("", "_self")}><i className="fa fa-linkedin fa-lg"></i></span>
                                              <span onClick={()=> window.open("", "_self")}><i className="fa fa-pinterest fa-lg"></i></span>
                                              <span onClick={()=> window.open("", "_self")}><i className="fa fa-rss fa-lg"></i></span> */}
                {/* </div>
                                      </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
